<template>
  <section class="wrapper home_wrapper">
    <div class="container">
      <div class="row row-header">
        <div class="col-sm-12">
          <toggle-button @change="toggleTheme" :value="isDarkMode" :labels="{checked: 'Light', unchecked: 'Dark'}" :color="{checked: '#989898', unchecked: '#383838'}" :width="60" />
        </div>
      </div>
      <div class="row row-margin-bottom">
        <div class="col-sm-12">
          <div class="graphBox box">
            <div class="h1 text-center">Welcome to XCHPool's Proof of Space NFT collection!<br><br> </div>
            <h5 class = 'text-center'>{{ 'To Claim your own NFT, proving your space, log in to your "MY FARM" page and press the mint button' }}</h5>
            <h5 class = 'text-center'>Check out the collection on <a target=_blank href="https://dexie.space/offers/col1rn6guus82v3yc75fsde352pz4zkljc8hzlt2ervzdtmut9p9n6gsyh3pxs/xch">Dexie</a> or <a target=_blank href="https://mintgarden.io/collections/xchpool-member-nfts-from-www.x-col1rn6guus82v3yc75fsde352pz4zkljc8hzlt2ervzdtmut9p9n6gsyh3pxs">Mintgarden</a></h5>
            
          </div>
        </div>
      </div>
            <div class="row row-margin-bottom">
                <div class="col-sm-12">
                    <div class="box box-padding">
                        <h5>Overview of all currently minted NFT's per type<br><br></h5>
                        <div class="h1">
                          <vue-good-table
                            id ="nftTable"
                            :columns="columns"
                            :rows="nfts"
                            :theme="tableTheme"

                            :pagination-options="{
                              enabled: true,
                              mode: 'records',
                              perPage: 20,
                              position: 'bottom',
                              perPageDropdownEnabled: false,
                              perPageDropdown: [20, 50, 100],
                              dropdownAllowAll: false,
                              setCurrentPage: 1,
                              nextLabel: $t('memberList-screen.tableNextLabel'),
                              prevLabel: $t('memberList-screen.tablePrevLabel'),
                              rowsPerPageLabel: $t('memberList-screen.tableLinesPerPagesLabel'),
                              ofLabel: $t('memberList-screen.tableOfLabel'),
                              pageLabel: $t('memberList-screen.tablePageLabel'), 
                              allLabel: $t('memberList-screen.tableAllLabel') 
                            }"
                            @on-row-click="toMemberSearch"
                            >
                            <template slot="table-row" slot-scope="props">
                              <span v-if="props.column.field == 'type'">
                                <h3><span v-if="props.row.type">{{ props.row.type }}</span></h3>
                                <span v-if="!props.row.type">{{ props.row.type }}</span>
                              </span>
                              <span v-if="props.column.field == 'total'">
                                <h3><span>{{ props.row.total }}</span></h3>
                              </span>
                              <span v-if="props.column.field == 'url'">
                                <img style="max-width: 100px" :src="props.row.url">
                              </span>
                            </template>
                          </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  </section>
</template>

<script>
import https from "https";



export default {
  name: "NftList",
  data() {
    return {
      theme: '',
      isDarkMode: false,
      tableTheme: 'black-rhino', //polar-bear 
      columns: [{
          label: 'Type',
          field: 'type',
        },
        {
          label: 'NFTs minted',
          field: 'total',
          type: 'number',
        },
        {
          label: 'Picture',
          field: 'url',
          type: 'image',
        }
      ],
      nfts: [],
    };
  },

  methods: {
    init() {
      const agent = new https.Agent({
        rejectUnauthorized: false,
      });
      this.$axios
        .get("v1/nfts/list", {
          httpsAgent: agent,
        })
        .then((res) => {
          this.nfts = Object.values(res.data);
        });
    },

    toggleTheme() {
                this.theme = this.theme == 'darkMode' ? '' : 'darkMode'; //toggles theme value
                document.documentElement.setAttribute('data-theme', this.theme); // sets the data-theme attribute
                localStorage.setItem('theme', this.theme); // stores theme value on local storage
                this.updateGraphTheme(this.theme);
    },
    updateGraphTheme(theme) {
        if(theme == 'darkMode'){
            this.tableTheme = "black-rhino",
            this.isDarkMode = true;
        }else{
            this.tableTheme = "polar-bear",
            this.isDarkMode = false;
        }
        
    }
  },

  created() {
    this.init();
    let localTheme = localStorage.getItem('theme'); //gets stored theme value if any
    document.documentElement.setAttribute('data-theme', localTheme);
    this.theme = localTheme;
    this.updateGraphTheme(this.theme);
  }
};

</script>

<style lang="scss" scoped>
.theme--light.v-application {
      background: transparent;
    }
</style>